module.exports = __webpack_public_path__ + "images/90f46146b6d3baa2332f2adca2fe9e60.svg";